module.exports = __webpack_public_path__ + "img/3k-europa.3ee2210a.jpg";